import React from "react";
import PropTypes from "prop-types";
import {
  Select,
  MenuItem,
  FormControl,
  Stack,
  Typography,
  FormHelperText,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export const SelectDropdown = ({
  name,
  label,
  value,
  options,
  placeholder,
  handleChange,
  style,
  isRequired,
  error,
  disabled,
}) => {
  return (
    <>
      <Stack className="mx-2">
        <FormControl size="small">
          <Typography className="poppins-font-family mb-1 field-label">
            {label} {isRequired && <span className="helper-text"> *</span>}
          </Typography>
          <Select
            sx={{
              height: 40,
            }}
            style={style}
            IconComponent={KeyboardArrowDownIcon}
            value={value ? value : "Select"}
            name={name}
            className="input-box"
            onChange={handleChange}
            placeholder={placeholder}
            displayEmpty
            disabled={disabled}
            renderValue={
              value !== "" ? undefined : () => "- - - Please Select - - -"
            }
          >
            <MenuItem value="" disabled>
              {"Select"}
            </MenuItem>
            
                {options?.map((itm, index) => (
                  <MenuItem key={index} value={itm?.value}>
                    {itm?.label}
                  </MenuItem>
                ))}
              
          </Select>
          <FormHelperText
            style={{ marginLeft: "-2px" }}
            error
            className={`helper-text`}
          >
            {error}
          </FormHelperText>
        </FormControl>
      </Stack>
    </>
  );
};

SelectDropdown.prototype = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.object,
  options: PropTypes.array,
  placeholder: PropTypes.array,
  handleChange: PropTypes.func,
  style: PropTypes.any,
  isRequired: PropTypes.bool,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};
